import React, { createContext, useContext, useEffect, useState } from 'react';

interface DarkModeContextType {
    isDark: boolean;
    toggleDark: () => void;
}

const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined);

export const DarkModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isDark, setIsDark] = useState(() => localStorage.getItem('lms-dark-mode') === 'true');

    useEffect(() => {
        document.documentElement.classList.toggle('dark', isDark);
        localStorage.setItem('lms-dark-mode', String(isDark));
    }, [isDark]);

    return (
        <DarkModeContext.Provider value={{ isDark, toggleDark: () => setIsDark(v => !v) }}>
            {children}
        </DarkModeContext.Provider>
    );
};

export const useDarkMode = () => {
    const ctx = useContext(DarkModeContext);
    if (!ctx) throw new Error('useDarkMode must be used inside DarkModeProvider');
    return ctx;
};
